import queryKeys from '@/constants/queryKeys';
import { getCurrentOrganizationContext } from '@/services/api/requests/super-admin';
import { useQuery } from '@tanstack/react-query';

const useCurrentOrganizationContext = () => {
  const { isLoading, data, error, isSuccess } = useQuery({
    queryKey: [queryKeys.superAdmin.currentOrganizationContext],
    staleTime: 5 * 60 * 1000, // 5 minutes
    queryFn: async () => {
      const context = await getCurrentOrganizationContext();
      return context;
    },
  });

  return {
    isLoading,
    data,
    error,
    isSuccess,
  };
};

export default useCurrentOrganizationContext;
